import Api from '../../shared/services/api'

const baseUrl = "serviceTypes";
export default {

  typeHead(searchTerm, all) {
    const qParams = new URLSearchParams({ searchTerm, all });
    return Api().get(`${baseUrl}/typeHead?${qParams.toString()}`);
  },
  get() {
    return Api().get(baseUrl);
  },
  edit(entity) {
    if (entity.id) return Api().put(`${baseUrl}/${entity.id}`, entity);
    return this.add(entity);
  },
  add(entity) {
    return Api().post(baseUrl, entity);
  },
  delete(id) {
    return Api().delete(`${baseUrl}/${id}`);
  }
}